import { TWorkflowView } from "@elixir/types";
import fetch from "../../fetch-client";
import { GET_TRYST_HOST } from "../../constants/env";
import { TrystGenericResponse } from "../../types/tryst";

export default async function postCreateWorkflowView(
  data: TWorkflowView
): Promise<TrystGenericResponse<TWorkflowView>> {
  try {
    const TRYST_HOST = GET_TRYST_HOST();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify(data);

    const requestOptions: RequestInit = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
      credentials: "include",
      mode: "cors",
    };

    const response = await fetch(`${TRYST_HOST}/workflow-view`, requestOptions);
    return await response.json();
  } catch (error) {
    return { success: false };
  }
}
